module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAA6CAQAAAD4+qq5AAABV0lEQVR4Aa3Wr2uWURQA4PPKVD4Ggk4wfGELlgXLiksGxWAzuSCziEGTSYNMcBg0mTSIxWGYyWYQy4dhFothZWGGBUEZiC8f6vB9xH/gnHLvrQ8X7r3nV/xf5kW+Qzjvp6WKzekx0VWnbYKVii2YYtcoZ2EdrFVs1h5645yFVbBRsc4WBss5C8sGbOlyFjbAasXGeuyZzVlYA+sVG9nF1ELOwgrYrFhngsG5nIUlf/HJoZyFF+B6xU75ga+O5SzcBY8qdtQOfjmds3AZvKlYeA8uVOyMA3w2k7PwDNys2En7+OZ4zsJt8KRih23jj8WchUvgbRM2YxsHFhtcYc4+vlcP8hTcavJZ78DFBoF0xA5+V2F5BzxukjLPwY0m6TyBqjhcAa+bFK574GGTovoSXBMZO2vAR12D9nEVvGrS2h6A+yJj86b4YtSgiZ/Q44OuyYAR6nEl/gGDV+vyZBuN5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./images/slide-arrow.png
// module id = 105
// module chunks = 2